import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'rds-c-select-table-decorators',
  templateUrl: './decorators.component.html',
  styleUrls: ['./decorators.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RdsSelectTableDecoratorsComponent {
  /** Map of URIs that represent the columns with applied filters */
  @Input() appliedFilters: { [uri: string]: boolean } = {};
  /** Map of URIs that represent key columns */
  @Input() keyColumns: { [uri: string]: boolean } = {};
  /** Whether the toggled columns represent the packaged, or unpackaged.*/
  @Input() toggledAreSelected = true;
  /** Map of URIs that represent columns which have been included/excluded from packaging */
  @Input() toggledColumns: { [uri: string]: boolean } = {};
  /** URI of the variable to decorate */
  @Input() uri: string | undefined;
}
